import { useMutation } from "@tanstack/react-query";
import { ProviderInfo } from "../Components/utils";
import { API_BASE } from "../constants";

const addProviderData = async (providerInfo: ProviderInfo) => {
  const path = `${API_BASE}/api/provider/submit`;
  const response = await fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(providerInfo),
  });

  return await response;
};

export const useAddProviderData = () => {
  return useMutation({
    mutationFn: (providerInfo: ProviderInfo) => addProviderData(providerInfo),
  });
};
